export default "__VITE_ASSET__b7ceaf78__"